<template>
  <div>
    <h4 class="text-black font-weight-bold my-4">Per quale motivo richiedi il consulto?</h4>
    <div v-if="!selQuest" class="d-flex">
      <div class="d-flex col-1 align-content-center" :class="isMobile && 'px-0'">
        <b-button
          type="button"
          variant="light"
          size="sm"
          @click="scrollRight"
          :style="{ 'background-image': `url(${'/svg/arrow_left.svg'})` }"
          class="col-12 arrow ml-auto mr-0"
        ></b-button>
      </div>
      <div
        class="d-flex mx-auto no-wrap scroller disable-scrollbars justify-content-between"
        v-if="tipo != 'farmacista'"
      >
        <b-button
          variant="secondary font-weight-bold"
          class="my-2 text__control"
          :class="isMobile ? 'mx-2 col-7 ' : 'col-sm-5 col-md-3 col-lg-2 mx-4'"
          v-for="(questionario, ind) in elenco"
          :key="ind"
          :ref="'btn' + ind"
          @click="selectThis(questionario)"
        >{{ind === 0 ? "Consulto Diretto" : questionario.nome }}</b-button>
      </div>
      <div
        class="d-flex mx-auto no-wrap scroller disable-scrollbars justify-content-between"
        v-else
      >
        <b-button
          variant="secondary font-weight-bold"
          class="my-2 text__control"
          :class="isMobile ? 'mx-2 col-10 ' : 'col-8 mx-4'"
          ref="btn0"
          @click="selectThis(elenco[0])"
        >{{ elenco[0].nome }}</b-button>
      </div>
      <div class="d-flex col-1 align-content-center" :class="isMobile && 'px-0'">
        <b-button
          :style="{ 'background-image': `url(${'/svg/arrow_right.svg'})` }"
          type="button"
          variant="light"
          @click="scrollLeft"
          class="col-12 arrow ml-0 mr-auto"
        ></b-button>
      </div>
    </div>
    <div v-else>
      <questionario-component :questionario="selQuest" v-on:end-quest="sendQuest($event)"></questionario-component>
    </div>
  </div>
</template>
<script>
export default {
  name: "step-due",
  props: ["tipo"],
  data() {
    return {
      selQuest: null,
      elenco: null,
      questionario_id: null,
      scroll: 0
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    }
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "questionario/all";
      this.$axios
        .get(url)
        .then(res => {
          // if (this.isFarmacista) {
          //   this.elenco = [];
          //   this.elenco.push(res.data.data[0]);
          // } else {
          this.elenco = res.data.data;
          // }
          // console.log(this.elenco);
        })
        .catch(() => {});
    },
    selectThis(questionario) {
      this.questionario_id = questionario.id;
      this.selQuest = JSON.parse(questionario.template);
      // console.log("selected quest", this.selQuest);
    },
    sendQuest(domande) {
      this.$emit("add-disturbo", {
        domande: domande,
        nome: this.selQuest.nome,
        questionario_id: this.questionario_id
      });
      this.selQuest = null;
    },
    scrollLeft() {
      this.scroll = this.scroll - 130;
      // this.scroll = this.scroll - 100;
      for (let i = 0; i < this.elenco.length; i++) {
        this.$refs["btn" + i][0].style.transform =
          "translateX(" + this.scroll + "%)";
      }
    },
    scrollRight() {
      if (this.scroll < 0) {
        this.scroll = this.scroll + 130;
        for (let i = 0; i < this.elenco.length; i++) {
          this.$refs["btn" + i][0].style.transform =
            "translateX(" + this.scroll + "%)";
        }
      }
    }
  },
  created() {
    this.fetchData();
    // console.log("isFarmacista", this.tipo);
  }
};
</script>
<style>
.text__control {
  white-space: initial;
  word-wrap: break-word;
}
.scroller {
  overflow-x: scroll;
  max-width: 80vw;
  transition: all 0.4s;
}
.scroller button {
  transition: all 0.4s;
  min-height: 81px;
}

.disable-scrollbars::-webkit-scrollbar {
  width: 0px !important;
  background: transparent; /* Chrome/Safari/Webkit */
}

.disable-scrollbars {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}
.arrow {
  background-position: center;
  background-repeat: no-repeat;
}
</style>
